// style loading
require('angular-vs-repeat/dist/angular-vs-repeat.min.css');
require('./assets/style/module.less');

// js loading
require('./common/index');
require('./documentation/index');
require('./nap/index');

/**
 * Define a local JSON file for traductions
 * @param $translateProvider
 */
function translateConfigurer($translateProvider) {
    $translateProvider.translations('fr', require('./assets/locales/locale-fr.json'));
}

function analyticsConfigurer(AnalyticsProvider, WCConstants) {
    AnalyticsProvider
        // .enterDebugMode(true)
        .setAccount(WCConstants.appConfig.analytics.UA)
        .setDomainName(WCConstants.appConfig.analytics.domain)
        .useDisplayFeatures(true)
        .trackUrlParams(true)
        .setPageEvent('$stateChangeSuccess')
        .setHybridMobileSupport(true);
}

angular
    .module('app.portail', ['app.portail.common', 'app.portail.documentation', 'app.portail.nap'])
    .config(translateConfigurer)
    .config(analyticsConfigurer)
    // eslint-disable-next-line
    .run(['Analytics', function (Analytics) { }]);
